const GET_ROLE_REQUESTS = 'GET_ROLE_REQUESTS';
const CREATE_NEW_ROLE_REQUEST = 'CREATE_NEW_ROLE_REQUEST';
const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
const FETCH_ROLE_REQUESTS = 'FETCH_ROLE_REQUESTS';
const REMOVE_DATA = 'REMOVE_DATA';
const SET_DATA = 'SET_DATA';
const GET_REQUESTS_STATUSES = 'GET_REQUESTS_STATUSES';

export default {
	GET_ROLE_REQUESTS,
	CREATE_NEW_ROLE_REQUEST,
	UPDATE_ROLE_REQUEST,
	FETCH_ROLE_REQUESTS,
	REMOVE_DATA,
	SET_DATA,
	GET_REQUESTS_STATUSES,
};
